<template>
  <div>
    <!-- Variant A -->
    <PaywallVariantA
      v-if="variant === 'A' && showVariantA && show"
      :isVisible="isVisible"
      :userCredit="userCredit"
      :totalCookies="totalCookies"
      :expiresAt="variantAExpiresAt"
      :triggerSource="triggerSource"
      :referrer="referrer"
      @close="handleClose"
      @activate="handleActivate"
    />

    <!-- Variant B -->
    <PaywallVariantB
      v-if="variant === 'B'"
      :isVisible="isVisible && variant === 'B' && show"
      :userCredit="userCredit"
      :totalCookies="totalCookies"
      :triggerSource="triggerSource"
      :referrer="referrer"
      @close="handleClose"
      @activate="handleActivate"
    />

    <!-- Variant C -->
    <PaywallVariantC
      v-if="variant === 'C'"
      :isVisible="isVisible && variant === 'C' && show" 
      :userCredit="userCredit"
      :totalCookies="totalCookies"
      :triggerSource="triggerSource"
      :referrer="referrer"
      @close="handleClose"
      @activate="handleActivate"
    />
  </div>
</template>

<script>
import axios from 'axios';
import PaywallVariantA from './PaywallVariantA.vue';
import PaywallVariantB from './PaywallVariantB.vue';
import PaywallVariantC from './PaywallVariantC.vue';

export default {
  name: 'PaywallABTest',
  components: {
    PaywallVariantA,
    PaywallVariantB,
    PaywallVariantC
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    userCredit: {
      type: Number,
      default: 0
    },
    totalCookies: {
      type: Number,
      default: 5
    },
    triggerSource: {
      type: String,
      default: 'Chat' // 'Chat', 'Image', 'Video'
    },
    referrer: {
      type: String,
      default: null // 'Onboarding', 'DailyLimit', etc.
    }
  },
  data() {
    return {
      variant: 'B', // Default to B
      showVariantA: false,
      isLoading: false,
      show: false,
      variantAExpiresAt: null
    };
  },
  watch: {
    isVisible(newVal) {
      if (newVal && !this.isLoading) {
        this.show = true;
        //this.fetchVariant();
      }
    }
  },
  methods: {
    async fetchVariant() {
      try {
        this.isLoading = true;
        const token = localStorage.getItem('token');
        if (!token) {
          this.variant = 'B';
          return;
        }

        const response = await axios.get(
          `https://api.roboo.ir/api/ABTest/GetVariant?Token=${token}`
        );

        if (response.data && response.data.variant) {
          this.variant = response.data.variant;
          
          // For Variant A, check if it's still valid (within 12 hours and first time)
          if (this.variant === 'A') {
            const expiresAt = response.data.variantAExpiresAt;
            this.variantAExpiresAt = expiresAt;
            
            if (expiresAt) {
              const expiresDate = new Date(expiresAt);
              const now = new Date();
              
              // Show Variant A only if:
              // 1. Not expired (within 12 hours)
              // 2. First time seeing paywall OR hasn't seen it yet
              if (expiresDate > now) {
                this.showVariantA = true;
              } else {
                // Switch to Variant B if Variant A expired or already seen
                this.variant = 'B';
                this.showVariantA = false;
                this.variantAExpiresAt = null;
              }
            } else {
              this.showVariantA = true;
            }
          } else {
            this.showVariantA = false;
            this.variantAExpiresAt = null;
          }
        }
      } catch (error) {
        console.error('Error fetching variant:', error);
        // Default to Variant B on error
        this.variant = 'B';
        this.showVariantA = false;
      } finally {
        this.show = true;
        this.isLoading = false;
      }
    },
    handleClose() {
      this.$emit('close');
    },
    handleActivate(data) {
      this.$emit('activate', data);
    }
  },
  mounted() {
    if (this.isVisible) {
      //this.fetchVariant();
      this.show = true;
    }
  }
};
</script>

<style scoped>
/* Styles are handled by individual variant components */
</style>

